import React from 'react';
import { observer } from 'mobx-react';
import './../../scss/common/loader.scss';
import { useStore } from '../../store/storeUtils';
const Loader = observer(({
  show = true,
  whiteLoader = false
}) => {
  const store = useStore();
  store.updateLoaderCount();
  return show ? /*#__PURE__*/React.createElement("div", {
    className: `loader-container ${whiteLoader ? 'white' : 'black'} loading-count`
  }, /*#__PURE__*/React.createElement("div", {
    className: "spinner"
  }, /*#__PURE__*/React.createElement("div", {
    className: "bounce1"
  }), /*#__PURE__*/React.createElement("div", {
    className: "bounce2"
  }), /*#__PURE__*/React.createElement("div", {
    className: "bounce3"
  }))) : null;
});
export default Loader;